var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.234,
    height: 18.238,
    viewBox: "0 0 18.234 18.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.126,17.308l-4.432-4.432a7.782,7.782,0,1,0-.768.768l4.432,4.432a.549.549,0,0,0,.384.162.533.533,0,0,0,.384-.162A.547.547,0,0,0,18.126,17.308ZM1.138,7.776a6.684,6.684,0,1,1,6.684,6.688A6.692,6.692,0,0,1,1.138,7.776Z",
    transform: "translate(-0.05)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.2a88b9e564800e2b1e0691def6d19e6d.svg";
export { ForwardRef as ReactComponent };